var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowAccept(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_733",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18.643px",
    height: "14.915px",
    viewBox: "0 0 18.643 14.915",
    enableBackground: "new 0 0 18.643 14.915",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-check",
    fill: "#707070",
    d: "M6.525,7.457c2.06,0.002,3.731-1.666,3.733-3.725S8.592,0.001,6.533-0.001 C4.474-0.003,2.802,1.665,2.8,3.724c0,0.001,0,0.003,0,0.005C2.8,5.787,4.467,7.456,6.525,7.457z M9.135,8.389H8.649 c-1.347,0.621-2.899,0.621-4.247,0H3.915c-2.161,0-3.912,1.75-3.915,3.91v1.213c0,0.773,0.627,1.4,1.399,1.4h10.252 c0.773,0,1.4-0.627,1.4-1.4v-1.213C13.049,10.139,11.296,8.389,9.135,8.389L9.135,8.389z M18.544,4.649L17.734,3.83 c-0.134-0.135-0.353-0.136-0.487-0.001c-0.001,0-0.001,0-0.001,0.001l-3.054,3.03l-1.324-1.337 c-0.135-0.135-0.354-0.135-0.488-0.001c0,0-0.001,0-0.001,0.001l-0.819,0.813c-0.135,0.134-0.136,0.353-0.001,0.488 c0,0,0.001,0.001,0.001,0.001l2.38,2.4c0.135,0.135,0.354,0.135,0.488,0.001c0-0.001,0.001-0.001,0.001-0.001l4.116-4.084 c0.134-0.136,0.134-0.354,0-0.489V4.649z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowAccept);
export default __webpack_public_path__ + "static/media/row-accept.72d601c11ebd0217f90476ed7d9670ee.svg";
export { ForwardRef as ReactComponent };